import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import OT from "@opentok/client";
import "./VonageStyle.css";
import "./components/VonageHardwareSetup.css";
import VonageControlpanel from "./components/VonageControlpanel";
import VonageGridView from "./components/VonageGridView";
import VonageFocusedView from "./components/VonageFocusedView";
import VonageScreenshare from "./components/VonageScreenshare";
import VonageSpotlightView from "./components/VonageSpotlightView";
import VonageSpeakerDialog from "./components/VonageSpeakerDialog";
import createOpentokHardwareSetupComponent from "./components/VonageHardwareSetup";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../constants/eventLabelGroups.contansts";
/* import * as bodyPix from "@tensorflow-models/body-pix";
import * as tf from "@tensorflow/tfjs";
import { NonMaxSuppressionV3 } from "@tensorflow/tfjs"; */

const VonageVideoClientModule = (props) => {
  const { hubConnection, lang, settings, clientName, companyName, channel, eventId, clientKey, view, onAir, orderList } = props;
  const { allowFullscreen, backstage, backgroundColor } = settings;
  const [showSpeakerDialog, setShowSpeakerDialog] = useState(false);
  const [showSpeakerDialogButton, setShowSpeakerDialogButton] = useState(false);
  const [showHardwareUnavailable, setShowHardwareUnavailable] = useState(false);
  const [gridViewFunctions, setGridViewFunctions] = useState(null);
  const [spotlightViewFunctions, setSpotlightViewFunctions] = useState(null);
  const [screenshareViewFunctions, setScreenshareViewFunctions] = useState(null);
  const [controlPanelFunctions, setControlPanelFunctions] = useState(null);
  const [hardwareSetupComplete, setHardwareSetupComplete] = useState(false);
  const [state, setState] = useState({
    token: null,
    streams: [],
    activeStream: null,
    screenshareStream: null,
    streamIdToMute: null,
    session: null,
    publisher: null,
    fullscreen: false,
    screensharePublisher: null,
    focusedStream: null,
    mainViewEl: null,
    focusViewStreamsRef: null,
    layoutMode: backstage ? "grid" : localStorage.getItem("vvcl") || "grid",
    myStreamRef: null,
    showSettingsView: false,
    hardwareSetup: null,
    screenshareLayout: "singleSpeaker",
    screenshareScreenRef: null,
    screenshareSpeakersRef: null,
    screenshareHiddenRef: null,
    spotlightViewHiddenRef: null,
    isModerator: false,
    moderatorLock: false,
    showControlbar: false,
  });
  const [showHwSetup, setShowHwSetup] = useState(false);
  const [showClickToJoin, setShowClickToJoin] = useState(false);
  const [hardwareSetupTimeout, setHardwareSetupTimeout] = useState(false);

  /*   const [net, setNet] = useState(null); */

  const stateRef = useRef();
  stateRef.current = state;
  const onStreamDestroyedRef = useRef();
  const onPublisherDestroyedRef = useRef();

  // const videoTag = useRef();
  // const canvasTag = useRef();
  // const imageTag = useRef();

  const onScreensharePublisherDestroyedRef = useRef();
  const { aspectRatio, requestedEventId } = settings;

  useEffect(() => {
    init(eventId, eventLabelGroupsConstants.VONAGE_LABEL_GROUP, lang);
    if (!localStorage.getItem("vvcl") || localStorage.getItem("vvcl") == "null") {
      localStorage.setItem("vvcl", "grid");
      stateRef.current.layoutMode = "grid";
    }
    if (hubConnection && hubConnection.state == 1) {
      let sessionType = backstage ? "SUBSCRIBER" : "PUBLISHER";
      if (view) {
        if (view == "LIVE" && !onAir) {
          sessionType = "SUBSCRIBER";
        } else {
          sessionType = "PUBLISHER";
        }
      }
      hubConnection.invoke("getSessionAndToken", requestedEventId || eventId, channel, clientKey, sessionType, false);
    }
    const mainViewEl = document.getElementById("vonage-mainview");
    // ro.observe(document.getElementById("vonage-module-wrap"));

    if (backstage && !props.toggleHardwareSetup) {
      let audioContextForTest = new AudioContext();
      if (audioContextForTest.state === "suspended") {
        setShowClickToJoin(true);
      }
    }
    else if (props.hardwareSetup) {
      setHardwareSetupComplete(true);
    }

    setState({ ...stateRef.current, mainViewEl });

    return () => {
      if (stateRef.current.session) {
        stateRef.current.streams.forEach((s) => {
          stateRef.current.session.unsubscribe(s);
        });
        if (stateRef.current.publisher) stateRef.current.session.unpublish(stateRef.current.publisher);
        if (stateRef.current.screensharePublisher) stateRef.current.session.unpublish(stateRef.current.screensharePublisher);
        if (stateRef.current.screenshareStream) stateRef.current.session.unsubscribe(stateRef.current.screenshareStream);
        stateRef.current.session.disconnect();
      }
    };
  }, []);
  useEffect(() => {
    if (typeof props.isStudioStream === "boolean" && stateRef.current.publisher) {
      stateRef.current.publisher.on("destroyed", () => startPublisher("restart"));
      stateRef.current.session.unpublish(stateRef.current.publisher);
    }
  }, [props.isStudioStream]);
  useEffect(() => {
    const { session } = stateRef.current;
    if (hubConnection && hubConnection.state == 1 && session) {
      let sessionType = backstage ? "SUBSCRIBER" : "PUBLISHER";
      if (view) {
        if (view == "LIVE" && !onAir) {
          sessionType = "SUBSCRIBER";
        } else {
          sessionType = "PUBLISHER";
        }
      }
      if ((sessionType === "PUBLISHER" && session.capabilities.publish !== 1) || (sessionType == "SUBSCRIBER" && session.capabilities.publish === 1)) {
        session.disconnect();
        hubConnection.invoke("getSessionAndToken", eventId, channel, clientKey, sessionType, false);
      }
    }
  }, [props.view, props.onAir]);
  useEffect(() => {
    if (!showHwSetup) {
      setHardwareSetupTimeout(true);
      setTimeout(() => setHardwareSetupTimeout(false), 1000);
    }
  }, [showHwSetup]);
  useEffect(() => {
    if (state.session && !state.session.connection && state.token
      && ((backstage && !showClickToJoin && !props.toggleHardwareSetup)
        || (backstage && hardwareSetupComplete && props.toggleHardwareSetup)
        || (!backstage && hardwareSetupComplete))) {
      state.session.connect(state.token, (error) => {
        // If the connection is successful, publish to the session
        if (error) {
          handleError(error);
        } else {
          if (state.session.capabilities.publish === 1) {
            startPublisher();
          }
        }
      });
    }
  }, [state.session, state.session?.connection, hardwareSetupComplete, state.token, showClickToJoin]);
  function checkSpotlightLayoutStatus() {
    const { layoutMode, streams, publisher } = stateRef.current;
    const currentSpotlights = spotlightViewFunctions?.current?.currentSpotlights;
    if (layoutMode != "spotlight" && layoutMode != "screenshare" && currentSpotlights && currentSpotlights.length > 0) {
      let match = false;
      if (publisher && publisher.stream && publisher.stream.name && currentSpotlights.includes(publisher.stream.name)) {
        toggleLayoutMode("spotlight");
        return;
      }
      for (const spot of spotlightViewFunctions.current.currentSpotlights) {
        if (streams.find((s) => s.stream.name == spot)) {
          toggleLayoutMode("spotlight");
          return;
        }
      }
    } else if (layoutMode == "spotlight") {
      if (spotlightViewFunctions?.current?.currentSpotlights.length > 0) {
        if (publisher && publisher.stream && publisher.stream.name && currentSpotlights.includes(publisher.stream.name)) {
          return;
        }
        for (const spot of spotlightViewFunctions.current.currentSpotlights) {
          if (streams.find((s) => s.stream.name == spot)) {
            return;
          }
        }
        toggleLayoutMode(localStorage.getItem("vvcl") || "grid");
      } else if (spotlightViewFunctions?.current?.currentSpotlights.length == 0) {
        toggleLayoutMode(localStorage.getItem("vvcl") || "grid");
      }
    }
  }

 
  function onActivateSpeaker(activeSpeaker) {
    if (activeSpeaker.badgeNo == clientKey) setShowSpeakerDialog(true);
  }
  useEffect(() => {
    const { activeStream, layoutMode, session } = stateRef.current;
    if (!activeStream && layoutMode == "focused") {
      setFocusedStream(null);
    }
    onStreamDestroyedRef.current = onStreamDestroyed;
    onPublisherDestroyedRef.current = onPublisherDestroyed;
    onScreensharePublisherDestroyedRef.current = onScreensharePublisherDestroyed;
    document.addEventListener("keydown", handleEsc);
    if (stateRef.current.liveSession) stateRef.current.liveSession.on("streamPropertyChanged", bindPropertyChanges);
    if (stateRef.current.backstageSession) stateRef.current.backstageSession.on("streamPropertyChanged", bindPropertyChanges);
    window.addEventListener("beforeunload", beforePageUnload);
    if (session) {
      session.on("streamCreated", onStreamCreated);
      session.on("sessionConnected", onSessionConnected);
    }
    if (hubConnection) {
      hubConnection.on("onGetSessionAndToken", onGetSessionAndToken);
      hubConnection.on("onChangeVonageScreenshareLayout", onChangeVonageScreenshareLayout);
      hubConnection.on("onActivateSpeaker", onActivateSpeaker);
    }
    return () => {
      document.removeEventListener("keydown", handleEsc);
      if (stateRef.current.liveSession) stateRef.current.liveSession.off("streamPropertyChanged", bindPropertyChanges);
      if (stateRef.current.backstageSession) stateRef.current.backstageSession.off("streamPropertyChanged", bindPropertyChanges);
      window.removeEventListener("beforeunload", beforePageUnload);
      if (session) {
        session.off("streamCreated", onStreamCreated);
        session.off("sessionConnected", onSessionConnected);
      }
      if (hubConnection) {
        hubConnection.off("onGetSessionAndToken", onGetSessionAndToken);
        hubConnection.off("onChangeVonageScreenshareLayout", onChangeVonageScreenshareLayout);
        hubConnection.off("onActivateSpeaker", onActivateSpeaker);
      }
    };
  });

  function onGetSessionAndToken(apiKey, sessionId, token) {
    const { hardwareSetup } = stateRef.current;
    var session = OT.initSession(apiKey, sessionId);
    stateRef.current.session = session;
    stateRef.current.token = token;

    if (!backstage || props.toggleHardwareSetup) {
      if (!hardwareSetup && !props.hardwareSetup) {
        initHardwareSetup();
        setShowHwSetup(true);
        if (props.toggleHardwareSetup && typeof props.toggleHardwareSetup == "function") props.toggleHardwareSetup(true);
        return;
      } else if (!hardwareSetup && props.hardwareSetup) {
        initHardwareSetup();
      }
    }
    setState({ ...stateRef.current });
    // session.connect(token, (error) => {
    //   // If the connection is successful, publish to the session
    //   if (error) {
    //     handleError(error);
    //   } else {
    //     if (session.capabilities.publish === 1) {
    //       startPublisher();
    //     }
    //   }
    // });
  }
  function onSessionConnected(e) {
    if (hubConnection && hubConnection.state == 1) {
      hubConnection.invoke("getScreenshareLayout", eventId, channel);
      hubConnection.invoke("getArchiveRecording", eventId, channel);
    }
    setState({ ...stateRef.current });
  }
  function onStreamCreated(event) {
    if (event.stream.videoType === "screen") {
      handleScreenshareStream(event);
    } else {
      handleCameraStream(event);
    }
  }
  function handleScreenshareStream(event) {
    const { session, layoutMode } = stateRef.current;
    let newScreenshareStream = session.subscribe(event.stream, "screenshare-container", {
      width: "auto",
      height: "100%",
      insertMode: "append",
      showControls: false,
    });
    const previousLayout = layoutMode;
    newScreenshareStream.on("destroyed", (event) => {
      onStreamDestroyedRef.current(event, previousLayout);
    });
    // screenshareResizeObserver.observe(newScreenshareStream.element);
    newScreenshareStream.element.style.aspectRatio = "16/9";
    setState({ ...stateRef.current, screenshareStream: newScreenshareStream });
    toggleLayoutMode("screenshare");
  }
  function handleCameraStream(event) {
    const { streams, session, layoutMode, screenshareLayout } = stateRef.current;
    var targetContainer = "vonage-subscribed-streams-container";
    var targetOptions = {
      insertMode: "append",
      width: "calc(100% - 10px)",
      height: "auto",
      showControls: false,
    };
    if (layoutMode == "grid") {
      targetContainer = "vonage-grid-hidden";
    } else if (layoutMode == "screenshare") {
      if (screenshareLayout == "singleSpeaker" || screenshareLayout == "noSpeaker") {
        targetContainer = "vonage-screenshare-hidden";
      } else {
        targetContainer = "vonage-screenshare-speakers";
      }
    }
    let newStream = session.subscribe(event.stream, targetContainer, targetOptions); //här
    newStream.on("destroyed", (e) => {
      onStreamDestroyedRef.current(e);
    });
    addMuteButton(newStream);
    addNametag(newStream);
    speakerDetection(newStream, setSubscriberStartTalking, setSubscriberStopTalking);
    newStream.element.addEventListener("click", (t) => setFocusedStream(t.currentTarget));
    newStream.element.style.aspectRatio = aspectRatio === "4:3" ? "4/3" : (aspectRatio === "16:10" ? "16/10" : "16/9")
    // ro.observe(newStream.element);
    streams.push(newStream);
    gridViewFunctions.current.onStreamConnected(newStream);
    screenshareViewFunctions.current.onStreamConnected(newStream);
    setTimeout(() => checkIfMuted(newStream), 1000);
    checkSpotlightLayoutStatus();
    setState({ ...stateRef.current }); //gratuitous setstate to trigger re-render
  }
  function checkIfMuted(newStream) {
    if (!newStream.element?.querySelector("video")) {
      return setTimeout(() => checkIfMuted(newStream), 1000);
    }
    var muted = newStream.element.querySelector("video").muted;
    if (muted) muteStream(newStream, true);
  }
  function addNametag(subscriber) {
    if (settings && (settings.showNametags === "ALWAYS" || settings.showNametags == "HOVER")) {
      var nametag = document.createElement("div");
      nametag.style.position = "absolute";
      nametag.style.top = "2%";
      nametag.style.right = "0px";
      nametag.style.left = "0px";
      nametag.style.color = "white";
      nametag.style.textAlign = "center";
      if (settings.showNametags == "HOVER") {
        nametag.classList.add("show-on-hover");
      }
      var order = orderList.find((x) => x.badgeNo == subscriber.stream.name);
      let streamName = order ? order.name : "Guest";
      if (order && order.company) {
        streamName += ", " + order.company;
      }
      var nameText = document.createElement("span");
      nameText.innerText = streamName;
      nameText.style.padding = "4px 10px";
      nameText.style.borderRadius = "5px";
      nameText.style.backgroundColor = "#17171794";
      nametag.appendChild(nameText);
      subscriber.element.appendChild(nametag);
    }
  }
  function addMuteButton(subscriber) {
    var btn = document.createElement("button");
    btn.classList.add("MuiButtonBase-root");
    btn.classList.add("MuiIconButton-root");
    btn.classList.add("mute-btn");
    // if (state.layoutMode == "grid") {
    btn.style.padding = "5px";
    // }

    btn.setAttribute("tabindex", 0);
    btn.setAttribute("type", "button");

    var span = document.createElement("span");
    span.classList.add("MuiIconButton-label");
    btn.appendChild(span);

    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.classList.add("MuiSvgIcon-root");

    // if (state.layoutMode == "grid") {
    svg.style.fontSize = "1rem";
    // }
    svg.setAttribute("focusable", false);
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("aria-hidden", true);
    span.appendChild(svg);

    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute(
      "d",
      "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
    );
    svg.appendChild(path);

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      if (subscriber.getAudioVolume() > 0) {
        muteStream(subscriber, true);
      } else {
        muteStream(subscriber, false);
      }
    });
    subscriber.element.appendChild(btn);
  }
  function muteStream(subscriber, state) {
    var path = subscriber.element.querySelector(".mute-btn path");
    if (state) {
      subscriber.setAudioVolume(0);
      path.setAttribute(
        "d",
        "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
      );
    } else {
      subscriber.setAudioVolume(100);
      path.setAttribute(
        "d",
        "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
      );
      if (subscriber.element.querySelector("video").muted) {
        subscriber.element.querySelector("video").muted = false;
      }
    }
  }
  function setSubscriberStartTalking(subscriber) {
    if (stateRef.current.layoutMode == "focused") {
      if (stateRef.current.activeStream && stateRef.current.activeStream.widgetId != subscriber.widgetId && !stateRef.current.screenshareStream) {
        setFocusedStream(subscriber.element);
      }
    }

    gridViewFunctions.current.setNewPersonTalking(subscriber);
    screenshareViewFunctions.current.setNewPersonTalking(subscriber);

    subscriber.element.classList.toggle("is-speaking", true);
  }
  function setSubscriberStopTalking(subscriber) {
    subscriber.element.classList.toggle("is-speaking", false);
  }

  function speakerDetection(subscriber, startTalking, stopTalking) {
    var activity = null;
    subscriber.on("audioLevelUpdated", function (event) {
      var now = Date.now();
      if (event.audioLevel > 0.04) {
        if (!activity) {
          activity = { timestamp: now, talking: false };
        } else if (activity.talking) {
          activity.timestamp = now;
        } else if (now - activity.timestamp > 1000) {
          // detected audio activity for more than 1s
          // for the first time.
          activity.talking = true;
          if (typeof startTalking === "function") {
            startTalking(subscriber);
          }
        }
      } else if (activity && now - activity.timestamp > 3000) {
        // detected low audio activity for more than 3s
        if (activity.talking) {
          if (typeof stopTalking === "function") {
            stopTalking(subscriber);
          }
        }
        activity = null;
      }
    });
  }

  function onStreamDestroyed(event, previousLayout) {
    const { streams, screenshareStream, activeStream } = stateRef.current;
    if (previousLayout) toggleLayoutMode(previousLayout);
    var sIndex = streams.indexOf(streams.find((s) => s.widgetId === event.target.widgetId));
    if (sIndex != -1) {
      var disconnectedStream = streams.splice(sIndex, 1);
      if (disconnectedStream[0]) {
        gridViewFunctions.current.onStreamDisconnected(disconnectedStream[0]);
        screenshareViewFunctions.current.onStreamDisconnected(disconnectedStream[0]);
        spotlightViewFunctions.current.onStreamDisconnected(disconnectedStream[0]);
        checkSpotlightLayoutStatus();
      }
      if (activeStream && activeStream.widgetId === event.target.widgetId) {
        setState({ ...stateRef.current, activeStream: null });
        if (streams.length > 0) {
          setFocusedStream(streams[0].element);
        }
      } else {
        setState({ ...stateRef.current }); //gratuitous setstate to trigger re-render
      }
    } else if (screenshareStream && screenshareStream.widgetId == event.target.widgetId) {
      setState({ ...stateRef.current, screenshareStream: null });
      if (activeStream && activeStream.element) setFocusedStream(activeStream.element);
    }
  }
  function initHardwareSetup() {
    var hardwareSetup = createOpentokHardwareSetupComponent("vonage-setup-done", { insertMode: "before" }, (error) => {
      if (error && error == "NotReadableError") {
        setShowHardwareUnavailable(true);
      }
      if (error) console.error(error);
    });
    if (props.setHardwareSetup && typeof props.setHardwareSetup == "function") props.setHardwareSetup(hardwareSetup);
    setState({ ...stateRef.current, hardwareSetup });
  }
  function setFocusedStream(el) {
    const { layoutMode, focusViewStreamsRef, streams, activeStream, mainViewEl } = stateRef.current;
    if (layoutMode != "focused") return;
    if (typeof el === "string") {
      let s = streams.find((s) => s.stream.id === el);
      if (s) el = s.element;
    }
    if (focusViewStreamsRef && activeStream) {
      // activeStream.element.style.height = "calc(97% / 5)";
      activeStream.element.style.width = "98%";
      focusViewStreamsRef.appendChild(activeStream.element);
    }
    if (!el && streams.length < 1) return;
    else if (!el && streams.length > 0) el = streams[0].element;

    const newActiveStream = streams.find((s) => s.element === el);
    mainViewEl.appendChild(newActiveStream.element);
    newActiveStream.element.style.width = "100%";
    // calcHeight43(newActiveStream.element);
    setState({ ...stateRef.current, activeStream: newActiveStream });
  }
  function toggleLayoutMode(mode) {
    const { streams, publisher, gridViewHiddenRef, focusViewStreamsRef, myStreamRef } = stateRef.current;
    if (!gridViewHiddenRef) {
      return;
    }
    setState({ ...stateRef.current, layoutMode: mode, activeStream: null });
    if (mode != "screenshare" && mode != "spotlight") localStorage.setItem("vvcl", mode);
    if (mode == "grid") {
      if (publisher) {
        gridViewHiddenRef.appendChild(publisher.element);
      }
      streams.forEach((s) => {
        gridViewHiddenRef.appendChild(s.element);
      });
      gridViewFunctions.current.toggleGridView();
    } else if (mode == "focused") {
      if (publisher) {
        myStreamRef.appendChild(publisher.element);
      }
      streams.forEach((s) => {
        focusViewStreamsRef.appendChild(s.element);
      });
    } else if (mode == "screenshare") {
      toggleScreenshareLayout(stateRef.current.screenshareLayout);
    } else if (mode == "spotlight") {
      spotlightViewFunctions.current.toggleSpotlightView();
    }
  }
  function toggleScreenshareLayout(ssLayout) {
    const { screenshareStream, screenshareScreenRef, layoutMode, screensharePublisher } = stateRef.current;
    setState({ ...stateRef.current, screenshareLayout: ssLayout });
    if (layoutMode !== "screenshare") return;
    let screenShare = screensharePublisher ? screensharePublisher : screenshareStream;
    screenshareViewFunctions.current.toggleScreenshareView();

    screenshareScreenRef.appendChild(screenShare.element);
  }
  function logPublisherStats(publisher) {
    let prevStats = {};
    const publisherLogTimer = setInterval(() => {
      publisher.getStats((error, statsArray) => {
        if (error) {
          clearInterval(publisherLogTimer);
          return console.error(error);
        }
        statsArray.forEach((statsObj) => {
          let prevStatsObj = null;
          if (statsObj.connectionId) {
            prevStatsObj = prevStats[statsObj.connectionId];
            console.log("stats for connection", statsObj.connectionId);
          } else {
            prevStatsObj = prevStats;
          }
          const stats = statsObj.stats;
          if (prevStatsObj.video) {
            var videoBitRate = 8 * (stats.video.bytesSent - prevStatsObj.video.bytesSent);
            console.log("video bit rate: ", videoBitRate, "bps");
            var audioBitRate = 8 * (stats.audio.bytesSent - prevStatsObj.audio.bytesSent);
            console.log("audio bit rate: ", audioBitRate, "bps");
          }
          if (stats.connectionId) {
            prevStats[stats.connectionId] = stats;
          } else {
            prevStats = stats;
          }
        });
      });
    }, 1000);
  }
  async function getMediaTrack(deviceId) {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        deviceId: { exact: deviceId },
        aspectRatio: { exact: 1.7777777778 },
        height: { ideal: 720 },
      }
    }).catch(handleError);
    const videoTrack = stream.getVideoTracks()[0];
    return videoTrack;
  }
  async function startPublisher(param, callback) {
    const { session, layoutMode, hardwareSetup } = stateRef.current;

    var targetContainer = "vonage-my-stream";
    if (layoutMode == "grid") targetContainer = "vonage-grid-hidden";
    else if (layoutMode == "screenshare") {
      if (layoutMode == "singleSpeaker") targetContainer = "vonage-screenshare-hidden";
      else targetContainer = "vonage-screenshare-speaker";
    }
    let audioDeviceId = localStorage.getItem("com.opentok.hardwaresetup.audio");
    let videoDeviceId = localStorage.getItem("com.opentok.hardwaresetup.video");

    if (stateRef.current.publisher && param != "restart") {
      stateRef.current.publisher.setVideoSource(videoDeviceId).catch((error) => console.error(error.name));
      stateRef.current.publisher.setAudioSource(audioDeviceId).catch((error) => console.error(error.name));
      return;
    }
    else if(stateRef.current.publisher){
      stateRef.current.publisher.destroy();
    }
   
    const videoTrack = await getMediaTrack(videoDeviceId);
    var options = {
      insertMode: "append",
      width: "calc(100% - 10px)",
      height: "auto",
      audioSource: audioDeviceId,
      videoSource: videoTrack ? videoTrack : videoDeviceId,
      publishAudio: param !== "videoOnly" || !videoDeviceId ? true : false,
      publishVideo: param !== "audioOnly" || !audioDeviceId ? true : false,
      showControls: false,
      name: clientKey,
      fitMode: "cover",
      mirror: true
    };
    if (props.isStudioStream === true) {
      options.disableAudioProcessing = true;
    }
    if (typeof param === "object") options = { ...options, ...param };
    var publisher = OT.initPublisher(targetContainer, { ...options, }, handleError);
    publisher.on("destroyed", () => {
      onPublisherDestroyedRef.current();
    });
    session.publish(publisher, async (e) => {
      handleError(e);
      publisher.element.style.aspectRatio = aspectRatio === "4:3" ? "4/3" : (aspectRatio === "16:10" ? "16/10" : "16/9")
      speakerDetection(publisher, setSubscriberStartTalking, setSubscriberStopTalking);
      setState({ ...stateRef.current, publisher });
      if (hubConnection && hubConnection.state == 1) {
        hubConnection.invoke("LogPublisherStatus", session.id, eventId, channel, clientKey, false, "Start");
      }
      gridViewFunctions.current.onStreamConnected(publisher);
      screenshareViewFunctions.current.onStreamConnected(publisher);
      if (layoutMode == "screenshare") {
        toggleScreenshareLayout(stateRef.current.screenshareLayout);
      }
      checkSpotlightLayoutStatus();
      if (typeof callback === "function") callback();
    });
  }
  function stopPublisher() {
    const { publisher, session } = stateRef.current;
    if (session && publisher) {
      gridViewFunctions.current.onStreamDisconnected(publisher);
      session.unpublish(publisher);
      setState({ ...stateRef.current, publisher: null });
    }
  }
  function onPublisherDestroyed() {
    const { session } = stateRef.current;
    if (hubConnection && hubConnection.state == 1) {
      hubConnection.invoke("LogPublisherStatus", session.id, eventId, channel, clientKey, false, "Stop");
    }
  }
  function bindPropertyChanges({ changedProperty, newValue, stream }) {
    const { livePublisher, backstagePublisher, onAir, hardwareSetup } = stateRef.current;
    let publisher = onAir ? livePublisher : backstagePublisher;
    if (stream == publisher.stream) {
      if (changedProperty == "hasAudio") {
        if (props.hardwareSetup) {
          props.hardwareSetup.publishAudio = newValue;
        } else if (hardwareSetup) {
          hardwareSetup.publishAudio = newValue;
        }
      } else if (changedProperty == "hasVideo") {
        if (props.hardwareSetup) {
          props.hardwareSetup.publishVideo = newValue;
        } else if (hardwareSetup) {
          hardwareSetup.publishVideo = newValue;
        }
      }
    }
  }
  function changeVonageScreenshareLayout(newLayout) {
    hubConnection.invoke("changeVonageScreenshareLayout", eventId, channel, newLayout);
    toggleScreenshareLayout(newLayout);
  }
  const onChangeVonageScreenshareLayout = (newLayout) => {
    toggleScreenshareLayout(newLayout);
  };
  function startScreenshare() {
    const { publisher, session, layoutMode } = stateRef.current;
    // Screen sharing is available. Publish the screen.
    var screensharePublisher = OT.initPublisher(
      "vonage-screenshare-speakers",
      {
        height:"100%",
        width:"auto",
        resolution:"1280x720",
        videoSource: "screen",
        name: clientKey, //publisher && publisher.stream ? publisher.stream.id : props.clientName,
        insertMode: "append",
        showControls: false,
        disableAudioProcessing: false,
      },
      function (error) {
        if (error) {
          screensharePublisher.destroy();
          handleError(error);
        } else {
          session.publish(screensharePublisher, function (error) {
            if (error) {
              handleError(error);
            } else {
              if (hubConnection && hubConnection.state == 1) {
                hubConnection.invoke("LogPublisherStatus", session.id, eventId, channel, clientKey, true, "Start");
              }
              screensharePublisher.element.style.aspectRatio="16/9";
              toggleLayoutMode("screenshare");
            }
          });
        }
      }
    );
    screensharePublisher.on("destroyed", () => {
      onScreensharePublisherDestroyedRef.current();
    });
    // var test = document.createElement("span");
    // test.innerText = "screenshare";
    // publisher.element.appendChild(test);
    // screensharePublisher.element.appendChild(test);
    setState({
      ...stateRef.current,
      screensharePublisher: screensharePublisher,
    });
  }
  function onScreensharePublisherDestroyed() {
    stateRef.current.screensharePublisher = null;
    setState({ ...stateRef.current, screensharePublisher: null });
    if (hubConnection && hubConnection.state == 1) {
      hubConnection.invoke("LogPublisherStatus", stateRef.current.session.id, eventId, channel, clientKey, true, "Stop");
    }
    let previousLayout = localStorage.getItem("vvcl");
    toggleLayoutMode(previousLayout);
  }
  function stopScreenshare() {
    const { screensharePublisher } = stateRef.current;
    screensharePublisher.destroy();
  }

  function handleError(error) {
    if (error) {
      console.error(error);
    }
  }
  function handleEsc(e) {
    if ((e.key == "Escape" || e.key == "Esc" || e.keyCode == 27) && stateRef.current.fullscreen) {
      e.preventDefault();
      toggleFullscreen();
      return false;
    }
  }
  function toggleFullscreen(fs) {
    if (fs === true && stateRef.current.fullscreen == false) {
      setState({ ...stateRef.current, fullscreen: true });
      props.fullscreenRef.classList.add("vonage-fullscreen");
      // document.getElementById("vonage-module-wrap").classList.add("full-height");
    } else if (fs !== true) {
      if (props.fullscreenRef) {
        setState({ ...stateRef.current, fullscreen: !stateRef.current.fullscreen });
        if (stateRef.current.fullscreen == false) {
          props.fullscreenRef.classList.add("vonage-fullscreen");
          // document.getElementById("vonage-module-wrap").classList.add("full-height");
        } else {
          props.fullscreenRef.classList.remove("vonage-fullscreen");
          // document.getElementById("vonage-module-wrap").classList.remove("full-height");
        }
      }
    }
  }
  function beforePageUnload() {
    const { publisher, screensharePublisher, session } = stateRef.current;
    var data = new FormData();
    data.set("SessionId", session?.id);
    data.set("VonagePublishLogId", 0);
    data.set("Inserted", new Date().toISOString());
    data.set("EventId", eventId);
    if (channel) {
      data.set("channel", channel);
    }
    data.set("clientKey", clientKey);
    data.set("screenshare", false);
    data.set("message", "stop");

    if (publisher) {
      navigator.sendBeacon("./api/meeting/vPublisherEnd", data);
    }
    if (screensharePublisher) {
      data.set("screenshare", true);
      navigator.sendBeacon("./api/meeting/vPublisherEnd", data);
    }
  }

  const viewRef = useRef();
  useEffect(() => {
    viewRef.current.addEventListener("mousemove", resetMoverEvent, { once: true });
  }, []);
  const resetMoverEvent = () => {
    setState({ ...stateRef.current, showControlbar: true });
    viewRef.current.removeEventListener("mousemove", resetMoverEvent);
    setTimeout(() => {
      if (viewRef && viewRef.current) {
        setState({ ...stateRef.current, showControlbar: false });
        viewRef.current.addEventListener("mousemove", resetMoverEvent, { once: true });
      }
    }, 5000);
  };
  if (showClickToJoin) {
    return (
      <div
        ref={viewRef}
        id="vonage-module-wrap"
      >
        <div
          id="vonage-setupscreen"
          style={{
            display: "block",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 999,
          }}
        >
          <div
            id="vonage-hwsetup"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
              backgroundColor: "#333",
            }}
          >
            <div className="opentok-hardware-setup" style={{ color: "white", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <EventLabel2 name="ClickToJoinMessage" groupName="DigitalMeeting.Vonage" />
              <br></br>
              <button
                style={{
                  border: "0px",
                  borderRadius: "15px",
                  padding: "6px 12px",
                  backgroundColor: "rgb(22 88 197)",
                  color: "#fff",
                }}
                onClick={() => setShowClickToJoin(false)}
              >
                <EventLabel2 name="ClickToJoinButton" groupName="DigitalMeeting.Vonage" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (showHardwareUnavailable)
    return (
      <div
        ref={viewRef}
        id="vonage-module-wrap"
      >
        <div
          id="vonage-setupscreen"
          style={{
            display: "block",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 999,
          }}
        >
          <div
            id="vonage-hwsetup"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
              backgroundColor: "#333",
            }}
          >
            <div className="opentok-hardware-setup" style={{ color: "white", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <EventLabel2 name="DeviceInUseError" groupName="DigitalMeeting.Vonage" />
              <br></br>
              <button
                style={{
                  border: "0px",
                  borderRadius: "15px",
                  padding: "6px 12px",
                  backgroundColor: "rgb(22 88 197)",
                  color: "#fff",
                }}
                onClick={() => window.location.reload()}
              >
                <EventLabel2 name="DeviceInUseErrorReloadBtn" groupName="DigitalMeeting.Vonage" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  return (
    <div
      ref={viewRef}
      id="vonage-module-wrap"
    >
      <VonageScreenshare
        {...stateRef.current}
        toggleFullscreen={toggleFullscreen}
        allowFullscreen={allowFullscreen}
        currentSpotlights={spotlightViewFunctions?.current?.currentSpotlights || []}
        setScreenshareSpeakersRef={(r) => {
          if (r != null && stateRef.current.screenshareSpeakersRef != r) setState({ ...stateRef.current, screenshareSpeakersRef: r });
        }}
        setScreenshareScreenRef={(r) => {
          if (r != null && stateRef.current.screenshareScreenRef != r) setState({ ...stateRef.current, screenshareScreenRef: r });
        }}
        setScreenshareHiddenRef={(r) => {
          if (r != null && stateRef.current.screenshareHiddenRef != r) setState({ ...stateRef.current, screenshareHiddenRef: r });
        }}
        setFunctionsRef={(r) => {
          if (r != null && screenshareViewFunctions != r) setScreenshareViewFunctions(r);
        }}
      />
      <VonageFocusedView
        {...stateRef.current}
        setfocusViewStreamsRef={(r) => {
          if (r != null && stateRef.current.focusViewStreamsRef != r) setState({ ...stateRef.current, focusViewStreamsRef: r });
        }}
        setMyStreamRef={(r) => {
          if (r != null && stateRef.current.myStreamRef != r) setState({ ...stateRef.current, myStreamRef: r });
        }}
      />
      <VonageSpotlightView
        {...stateRef.current}
        hubConnection={hubConnection}
        eventId={requestedEventId || eventId}
        channel={channel}
        checkSpotlightLayoutStatus={checkSpotlightLayoutStatus}
        setHiddenRef={(r) => {
          if (r != null && stateRef.current.spotlightViewHiddenRef != r) setState({ ...stateRef.current, spotlightViewHiddenRef: r });
        }}
        setFunctionsRef={(r) => {
          if (r != null && spotlightViewFunctions != r) setSpotlightViewFunctions(r);
        }}
      />
      <VonageGridView
        {...stateRef.current}
        orderList={orderList}
        setGridViewHiddenRef={(r) => {
          if (r != null && stateRef.current.gridViewHiddenRef != r) setState({ ...stateRef.current, gridViewHiddenRef: r });
        }}
        setFunctionsRef={(r) => {
          if (r != null && gridViewFunctions != r) setGridViewFunctions(r);
        }}
      />
      {stateRef.current.session ? (
        <VonageControlpanel
          {...stateRef.current}
          backstage={backstage}
          view={props.view}
          disableControls={hardwareSetupTimeout || props.disableControls}
          showSpeakerDialog={showSpeakerDialog}
          startScreenshare={startScreenshare}
          stopScreenshare={stopScreenshare}
          startPublisher={startPublisher}
          stopPublisher={stopPublisher}
          toggleFullscreen={toggleFullscreen}
          toggelDeviceSettings={() => {
            if (props.toggleHardwareSetup && typeof props.toggleHardwareSetup == "function") props.toggleHardwareSetup(!showHwSetup);
            setShowHwSetup(!showHwSetup);
          }}
          fullscreen={stateRef.current.fullscreen}
          allowFullscreen={allowFullscreen}
          showControlbar={stateRef.current.showControlbar}
          isSomeoneSharingScreen={stateRef.current.screenshareStream != null}
          isSharingMyScreen={stateRef.current.screensharePublisher != null}
          toggleLayoutMode={toggleLayoutMode}
          changeScreenshareLayout={changeVonageScreenshareLayout}
          setFunctionsRef={(r) => {
            if (r != null && controlPanelFunctions != r) setControlPanelFunctions(r);
          }}
        />
      ) : null}
      <div
        id="vonage-setupscreen"
        style={{
          display: showHwSetup ? "block" : "none",
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          zIndex: 999,
        }}
      >
        <div
          id="vonage-hwsetup"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            backgroundColor: "#333",
          }}
        >
          <button
            id="vonage-setup-done"
            onClick={async () => {
              setHardwareSetupComplete(true);
              setShowHwSetup(false);

              if (props.toggleHardwareSetup && typeof props.toggleHardwareSetup == "function") props.toggleHardwareSetup(false);
              if (controlPanelFunctions && typeof controlPanelFunctions.current.setControlLock == "function") {
                controlPanelFunctions.current.setControlLock(true);
                setTimeout(() => {
                  controlPanelFunctions.current.setControlLock(false);
                }, 2500);
              }
              if (state.publisher) {
                let newAudioDeviceId = localStorage.getItem("com.opentok.hardwaresetup.audio");
                let newVideoDeviceId = localStorage.getItem("com.opentok.hardwaresetup.video");
                let newVideoTrack = await getMediaTrack(newVideoDeviceId);
                if (newAudioDeviceId !== state.publisher.getAudioSource()?.deviceId) state.publisher.setAudioSource(newAudioDeviceId);
                if (newVideoTrack.id !== state.publisher.getVideoSource()?.track?.id) startPublisher("restart");
              }
            }}
          >
            <EventLabel2 name="ConfirmCameraSettings" groupName="DigitalMeeting.Vonage" />
          </button>
        </div>
      </div>
      {showSpeakerDialog ? (
        <VonageSpeakerDialog
          {...stateRef.current}
          hubConnection={hubConnection}
          eventId={eventId}
          channel={channel}
          clientKey={clientKey}
          clientName={clientName}
          companyName={companyName}
          anchorEl={document.getElementById("speaker-dialog-anchor")}
          handleClose={() => setShowSpeakerDialog(false)}
          setStreamIdToMute={(id) => setState({ ...stateRef.current, streamIdToMute: id })}
        />
      ) : null}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : undefined,
  };
}
export default connect(mapStateToProps)(VonageVideoClientModule);
